import type { IconNode } from '../types';

/**
 * @name cloud-sync
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgMTgtMS41MzUgMS42MDVhNSA1IDAgMCAxLTgtMS41IiAvPgogIDxwYXRoIGQ9Ik0xNyAyMnYtNGgtNCIgLz4KICA8cGF0aCBkPSJNMjAuOTk2IDE1LjI1MUE0LjUgNC41IDAgMCAwIDE3LjQ5NSA4aC0xLjc5YTcgNyAwIDEgMC0xMi43MDkgNS42MDciIC8+CiAgPHBhdGggZD0iTTcgMTB2NGg0IiAvPgogIDxwYXRoIGQ9Im03IDE0IDEuNTM1LTEuNjA1YTUgNSAwIDAgMSA4IDEuNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cloud-sync
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CloudSync: IconNode = [
  ['path', { d: 'm17 18-1.535 1.605a5 5 0 0 1-8-1.5' }],
  ['path', { d: 'M17 22v-4h-4' }],
  ['path', { d: 'M20.996 15.251A4.5 4.5 0 0 0 17.495 8h-1.79a7 7 0 1 0-12.709 5.607' }],
  ['path', { d: 'M7 10v4h4' }],
  ['path', { d: 'm7 14 1.535-1.605a5 5 0 0 1 8 1.5' }],
];

export default CloudSync;
